import { CSSProperties } from 'react';

export const getActiveOpacity = (isLoading: boolean, isDisabled: boolean): number => {
  if (isLoading) {
    return 0.8;
  }
  if (isDisabled) {
    return 0.5;
  }
  return 0.8;
};

export const getRegularOpacity = (isLoading: boolean, isDisabled: boolean): number => {
  if (isLoading) {
    return 0.6;
  }
  if (isDisabled) {
    return 0.5;
  }
  return 1;
};

export const getButtonStyles = (
  type: 'button' | 'button-icon',
  radius: 'none' | 'half' | 'full',
  variant: 'contained' | 'outlined' | 'text',
  width?: 'full' | number,
  height = 40,
  noPadding?: boolean,
  htmlColor?: string,
  htmlTextColor?: string,
): CSSProperties => {
  const radiusMap = {
    none: 0,
    half: (height / 40) * 8,
    full: height / 2,
  };

  const styles: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    height: `${height / 10}rem`,
    borderRadius: `${radiusMap[radius] / 10}rem`,
    paddingLeft: type === 'button-icon' ? undefined : `${(height / 2) / 10}rem`,
    paddingRight: type === 'button-icon' ? undefined : `${(height / 2) / 10}rem`,
    overflow: 'hidden',
    color: htmlTextColor || '#ffffff',
  };

  if (width === 'full') {
    styles.width = '100%';
  } else
  if (typeof width === 'string') {
    styles.width = width;
  } else
  if (typeof width === 'number') {
    styles.width = `${width / 10}rem`;
  } else {
    styles.width = 'fit-content';
  }
  if (noPadding) {
    styles.padding = 0;
  }

  if (variant === 'contained') {
    styles.backgroundColor = htmlColor || '#454545';
    styles.borderWidth = 1;
    styles.borderStyle = 'solid';
    styles.borderColor = htmlColor || '#454545';
  }
  if (variant === 'outlined') {
    styles.borderWidth = 1;
    styles.borderStyle = 'solid';
    styles.borderColor = htmlColor || '#454545';
  }
  if (type === 'button-icon') {
    styles.backgroundColor = htmlColor || 'transparent';
    styles.borderWidth = 0;
    styles.padding = 0;
    styles.margin = 0;
  }

  return styles;
};
